import React, { Component } from "react";
import { withCookies } from 'react-cookie';
import { connect } from "react-redux";
import { bindActionCreators, compose } from 'redux';
import { Redirect } from "react-router-dom";
import { logout } from '../../modules/Auth';

class Logout extends Component {
  async componentDidMount() {
    const { cookies, logout } = this.props;

    await logout(cookies);
  }
 
  render() {
    const { authState: { isAuthenticated } } = this.props;
    return isAuthenticated ? null : <Redirect to="/login" />;
  }
}

Logout.propTypes = {
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logout: logout,
  }, dispatch)
}

export default compose(withCookies, connect(mapStateToProps, mapDispatchToProps))(Logout);
